export default {
  content: {
    class: ["p-3 flex flex-row"],
  },
  container: {
    class: ["flex flex-row justify-between w-full"],
  },
  itemsContent: {
    class: [],
  },
  itemsContainer: { class: ["flex"] },
};
